// extracted by mini-css-extract-plugin
export default {"loader":"FPALoader_loader__EHUX+","logo_dots":"FPALoader_logo_dots__qwrbj","loaderAnim":"FPALoader_loaderAnim__NlKJY"};